import { NavLink } from 'react-router-dom';

const items = [
  { to: '/', label: 'Overview' },
  { to: '/live', label: 'Live map' },
  { to: '/trips', label: 'Trips' },
  { to: '/drivers', label: 'Drivers' },
  { to: '/riders', label: 'Riders' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/payouts', label: 'Payouts' },
];

export function Sidebar() {
  return (
    <aside className="hidden w-56 shrink-0 border-r border-slate-200 bg-white lg:flex lg:flex-col">
      <div className="px-5 py-5">
        <p className="font-display text-xl font-bold tracking-tight text-slate-900">Raahi</p>
        <p className="text-xs font-medium uppercase tracking-wide text-slate-500">Admin</p>
      </div>
      <nav className="flex-1 px-2">
        <ul className="space-y-0.5">
          {items.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  'flex items-center rounded-md px-3 py-2 text-sm font-medium ' +
                  (isActive
                    ? 'bg-slate-900 text-white'
                    : 'text-slate-700 hover:bg-slate-100')
                }
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
}
